import type { $CornerCountersinkHoles, $KickPlateCountersinkHoles, $Plate } from 'metalworks-domain'
import { getHolePositions } from 'metalworks-domain'
import type { MeshStandardMaterial } from 'three'

import { createCountersinkHoleMesh } from './countersink-hole'

export const createCountersinkHoleMeshes = (
  hole: $CornerCountersinkHoles | $KickPlateCountersinkHoles,
  plate: Pick<$Plate, 'thickness' | 'handing' | '$sizeX' | '$sizeY'>,
  material: MeshStandardMaterial,
  count: { horizontal?: number; vertical?: number }
) => {
  const { topRadius, bottomRadius } = hole

  const plateSize = {
    x: plate.$sizeX,
    y: plate.$sizeY,
  }

  const holePositions = getHolePositions(hole, plateSize, count)

  return holePositions.map(position =>
    createCountersinkHoleMesh(
      { $absCoords: position, topRadius, bottomRadius },
      plate.thickness,
      plate.handing,
      material
    )
  )
}
